import { render, staticRenderFns } from "./CostCreateUpdate.vue?vue&type=template&id=28d39f00&scoped=true&"
import script from "./CostCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CostCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CostCreateUpdate.vue?vue&type=style&index=0&id=28d39f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d39f00",
  null
  
)

export default component.exports